import { useState } from 'react';

export const useCurrencyAmount = (finalRates, setFormikAmount) => {
    const [displayAmount, setDisplayAmount] = useState('');
    const [selectedCurrency, setSelectedCurrency] = useState('TL');

    // Yardımcı: TL'ye çevir
    const convertToTL = (baseAmountInSelectedCurrency, currencyToUse) => {
        let converted = baseAmountInSelectedCurrency;

        if (currencyToUse === 'USD' && finalRates?.usdFinalRate) {
            converted *= finalRates.usdFinalRate;
        } else if (currencyToUse === 'EUR' && finalRates?.eurFinalRate) {
            converted *= finalRates.eurFinalRate;
        } else if (currencyToUse === 'GBP' && finalRates?.gbpFinalRate) {
            converted *= finalRates.gbpFinalRate;
        }

        return converted;
    };

    const handleAmountChange = (e, newCurrency) => {
        const currencyToUse = newCurrency || selectedCurrency;
        const raw = (e.target.value || '').trim();

        // Her şeyi sildiyse
        if (!raw) {
            setDisplayAmount('');
            setFormikAmount('');
            return;
        }

        // Noktaları binlik ayırıcı olarak gör -> tamamen kaldır
        const noDots = raw.replace(/\./g, '');

        // Türk formatı: , ondalık ayırıcı
        const hasComma = noDots.includes(',');

        let intPartRaw = noDots;
        let fracPartRaw = '';

        if (hasComma) {
            const [intPart, fracPart] = noDots.split(',', 2);
            intPartRaw = intPart ?? '';
            fracPartRaw = fracPart ?? '';
        }

        // Sadece rakamları al
        const intDigits = (intPartRaw || '').replace(/\D/g, '');
        const fracDigits = (fracPartRaw || '').replace(/\D/g, '').slice(0, 2);

        // Hiç tam kısım yoksa ve virgül de yoksa (çöp/gereksiz karakter) -> dokunma
        if (!intDigits && !hasComma) {
            setDisplayAmount(raw);
            return;
        }

        // "00012" gibi olmasın
        const normalizedInt = intDigits ? String(parseInt(intDigits, 10)) : '0';

        // Numeric değeri oluştur (ondalık varsa . ile)
        let normalizedStr = normalizedInt;
        if (hasComma && fracDigits) {
            normalizedStr += '.' + fracDigits;
        }

        const baseAmountInSelectedCurrency = parseFloat(normalizedStr || '0') || 0;
        const convertedTLAmount = convertToTL(baseAmountInSelectedCurrency, currencyToUse);

        // Gösterim için binlik ayırıcı ekle
        const groupThousands = (s) => s.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        const groupedInt = normalizedInt ? groupThousands(normalizedInt) : '0';

        let display = groupedInt;
        if (hasComma) {
            if (noDots.endsWith(',')) {
                // Kullanıcı "12," yazıp henüz kuruş girmediyse
                display = `${groupedInt},`;
            } else {
                display = `${groupedInt},${fracDigits}`;
            }
        }

        setFormikAmount(convertedTLAmount);  // Formik'e TL değeri
        setDisplayAmount(display);           // Input’ta görünen değer
    };

    const handleCurrencyChange = (e) => {
        const newCurrencyValue = e.target.value;
        setSelectedCurrency(newCurrencyValue);
        // Mevcut displayAmount üzerinden yeni kura göre TL'yi tekrar hesapla
        handleAmountChange({ target: { value: displayAmount } }, newCurrencyValue);
    };

    return {
        displayAmount,
        selectedCurrency,
        handleAmountChange,
        handleCurrencyChange
    };
};